module.exports = __webpack_public_path__ + "static/media/4.4626a899.jpg";